export default __webpack_public_path__ + "static/media/at_2.79241e32.svg";